import { useEffect, useRef, useState } from 'react';

export const useDropDownTrigger = <T extends HTMLElement>() => {
  const [open, setOpen] = useState(false);
  const ref = useRef<T | null>(null);

  useEffect(() => {
    const handler = (event: MouseEvent | TouchEvent) => {
      if (open && ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener('mousedown', handler);
      document.addEventListener('touchstart', handler);
    }

    return () => {
      if (open) {
        document.removeEventListener('mousedown', handler);
        document.removeEventListener('touchstart', handler);
      }
    };
  }, [open]);

  const toggleOpen = () => {
    setOpen(prev => !prev);
  };

  return {
    open,
    toggleOpen,
    setOpen,
    ref,
  };
};
